export const lang =  {
	str_title: `Tiếng trung`,
	str_index: `trang đầu`,
	str_neiye: 'Lobby',
	str_activity: `Hoạt động`,
	str_service: `dịch vụ khách hàng`,
	str_my: `của tôi`,
	str_more: `Hơn`,
	str_save: `Lưu`,
	str_sure: `Xác nhận`,
	str_update: `Cập nhật`,
	str_serviceName: `liên hệ với dịch vụ khách hàng`,
	str_confirm: `xác nhận`,
	str_tabs_charge: `nạp tiền`,
	str_tabs_Withdrawal: `rút tiền`,
	str_tabs_integral: `điểm`,
	str_tabs_activity: `Hoạt động`,
	str_loginBefore: `Login`,
	str_loginBeforeBalance: `Register`,
	str_1_101: `làm cho một tài`,
	str_1_8: `1 phút xổ số`,
	str_1_9: `5 phút xổ số`,
	str_1_10: `5 phút đua`,
	str_1_11: `1 phút đua`,
	str_1_12: `1 giây Tài Xỉu`,
	str_1_13: `1 phút Tài Xỉu`,
	str_1_14: `1 giây Mark Six`,
	str_1_15: `1 phút 6 xổ số`,
	str_1_27: `Đĩa màu 1 giây `,
	str_1_28: `Đĩa màu 1 phút`,
	str_1_29: `Cá, tôm và cua trong 1 giây`,
	str_1_30: `Cá, tôm, cua 1 phút`,
	str_1_31: `Đoán 1 giây`,
	str_1_32: `Đoán 1 điểm`,
	str_1_203: `Xổ số miền nam 1`,
	str_1_204: `xổ số giữa 1`,
	str_1_205: `Xổ số miền bắc 1`,
	str_1_100: `Truyền tin`,
	str_1_102: `Trận chiến của ba vương quốc`,
	str_1_103: `ma cà rồng`,
	str_1_104: `Kho báu Ai Cập`,
	str_1_1000:`câu cá rồng`,
	str_1_1001:`câu cá sao`,
	str_1_1002:`Câu cá cổ`,
	str_1_1003:`Ngư lôi kéo`,
	str_1_1004:`Lục phát`,
	str_100_30300101: `Kho báu của Rồng`,
	str_100_30300501: `Goku câu cá`,
	str_100_30300201: `bò tiền mặt`,
	str_100_30300301: `Câu cá cóc vàng`,
	str_100_30300401: `Li Kui tách cá`,
	str_100_30300601: `Dasheng Naohai`,
	str_100_30300701: `cá sấu ba màu`,
	str_1_105: `Hồ Chí Minh`,
	str_1_106: `tháp đồng`,
	str_1_107: `Cà Mau`,
	str_1_108: `Bến tre`,
	str_1_109: `Vũng Tàu`,
	str_1_110: `Bạc Liêu`,
	str_1_111: `Đồng nai`,
	str_1_112: `Cần Thơ`,
	str_1_113: `Sóc Trăng`,
	str_1_114: `Tây Ninh`,
	str_1_115: `An giang`,
	str_1_116: `trơn tru`,
	str_1_117: `Wing Lung`,
	str_1_118: `Bình dương`,
	str_1_119: `Cha Rong`,
	str_1_120: `Long an`,
	str_1_121: `Bình Phúc`,
	str_1_122: `Hao Jiang`,
	str_1_123: `Thiên Giang`,
	str_1_124: `Kiến Giang`,
	str_1_125: `Đà lạt`,
	str_1_126: `Shunhua`,
	str_1_127: `Phúc An`,
	str_1_128: `Dele`,
	str_1_129: `Quang nam`,
	str_1_130: `Đà Nẵng`,
	str_1_131: `Thanh Hà`,
	str_1_132: `Ping Ding`,
	str_1_133: `GuangZhi`,
	str_1_134: `ก๋วงบินห์`,
	str_1_135: `Gia lai`,
	str_1_136: `Ninh thuận`,
	str_1_137: `nghĩa rộng`,
	str_1_138: `Delon`,
	str_1_139: `Kunsong`,
	str_1_140: `Hồ Chí Minh VIP`,
	str_1_200: `Phương bắc`,
	str_1_201: `Xổ số 18h25`,
	str_1_202: `Hà Nội VIP`,
	str_1_206: `xổ số xổ số một xu`,
	str_1_300: `Quay thử Xổ số Việt Nam một điểm`,
	str_2_0: `Tiền sảnh WM`,
	str_8_0: `Sảnh BBIN`,
	str_10_0: `Hội trường DG`,
	str_9_0: `Sảnh SEXY`,
	str_2_101: `Bài Baccarat`,
	str_2_102: `Rồng hổ`,
	str_2_103: `Trò chơi Roulette`,
	str_2_104: `Tài Xỉu`,
	str_2_105: `Niu Niu`,
	str_2_106: `Sangong`,
	str_2_107: `Fan Tan`,
	str_2_108: `đĩa màu`,
	str_2_110: `Cá, tôm và cua`,
	str_2_111: `hoa chiên vàng`,
	str_2_112: `Ôn Châu Pai Gow`,
	str_2_113: `28 thanh`,
	str_2_114: `Andabaha`,
	str_5_Unknown: ``,
	str_5_Soccer: `bóng đá`,
	str_5_Basketball: `bóng rổ`,
	str_5_Football: `Bóng bầu dục Mỹ`,
	str_5_IceHockey: `puck`,
	str_5_Badminton: `cầu lông`,
	str_5_Pool: `Bida / Snooker`,
	str_5_Motor_Sport: `đua xe`,
	str_5_Tennis: `quần vợt`,
	str_5_5_Baseball: `bóng chày`,
	str_5_Volleyball: `bóng chuyền`,
	str_5_Others: `khác`,
	str_5_Golf: `gôn`,
	str_5_Boxing: `quyền anh`,
	str_5_Cricket: `bóng chày`,
	str_5_Table_Tennis: `bóng bàn`,
	str_5_Rugby: `bóng bầu dục`,
	str_5_Handball: `bóng ném`,
	str_5_Cycling: `xe đạp`,
	str_5_Athletics: `Điền kinh`,
	str_5_Beach_Soccer: `bóng đá bãi biển`,
	str_5_Futsal: `đá bóng trong nhà`,
	str_5_Entertainment: `độc nhất`,
	str_5_Financial: `tài chính`,
	str_5_Darts: `Phi tiêu`,
	str_5_Olympic: `Thế vận hội`,
	str_5_Lacrosse: `dây chuyền bóng`,
	str_5_Water_Polo: `môn bóng nước`,
	str_5_Winter_Sports: `thể thao mùa đông`,
	str_5_Squash: `bí đao`,
	str_5_Field_Hockey: `khúc côn cầu`,
	str_5_Mixed_Martial_Arts: `Võ tổng hợp`,
	str_5_E_Sports: `Thể thao điện tử`,
	str_5_Gaelic_Football: `Bóng đá Gaelic`,
	str_5_Hurling: `板棍球`,
	str_5_Muay_Thai: `Muay Thái`,
	str_5_Aussie_Rules_Football: `Bóng đá nội quy Úc`,
	str_5_Bandy: `Bandy Ball`,
	str_5_Winter_Olympics: `Thế vận hội mùa đông`,
	str_6_1: `vua trái cây kim cương`,
	str_6_8: `Mật ngọt`,
	str_6_60: `vũ điệu rừng nhiệt đới`,
	str_6_2: `Thánh cờ vua`,
	str_6_10: `Ngũ phúc đến tận cửa`,
	str_6_35: `Crazy Nezha`,
	str_6_39: `đang bay`,
	str_6_57: `quyền bá chủ của quái thú`,
	str_6_54: `Ngựa bùn cháy cỏ`,
	str_6_66: `Nóng 777`,
	str_6_69: `thần tài`,
	str_6_70: `đầy đủ triệu rồng`,
	str_6_72: `chúc may mắn năm này qua năm khác`,
	str_6_74: `cái bát kho báu`,
	str_6_76: `Muốn muốn muốn`,
	str_6_77: `Phượng Hoàng Lửa`,
	str_6_78: `Thần Apollo`,
	str_6_80: `thần biển huyền thoại`,
	str_6_61: `Ăn đậu mỗi ngày`,
	str_6_55: `Truyền thuyết rồng`,
	str_6_68: `Ngộ Không ăn trộm đào`,
	str_6_204: `rương kho báu`,
	str_6_83: `nữ hoàng lửa`,
	str_6_1074: `Cornucopia JP`,
	str_6_1010: `Năm phước lành JP`,
	str_6_1067: `Kiếm quả trứng vàng JP`,
	str_6_92: `Giải vô địch bóng đá thế giới 2018`,
	str_6_86: `牛逼快跑`,
	str_6_95: `Giày thể thao World Cup`,
	str_6_96: `em bé bóng đá`,
	str_6_98: `Giải vô địch bóng đá World Cup`,
	str_6_105: `Nhảy cao bằng một tay`,
	str_6_104: `Mai mối bên bờ biển`,
	str_6_122: `Inca Zuma`,
	str_6_131: `Thần tài ngay thẳng`,
	str_6_113: `Thần tài bay`,
	str_6_146: `Đèn kho báu Julian`,
	str_6_147: `hoa phú quý`,
	str_6_148: `như một vị thần`,
	str_6_157: `Quyền anh năm hình`,
	str_6_150: `sinh nhật tóc lớn`,
	str_6_182: `Thor 2`,
	str_6_197: `Kho báu Panlong`,
	str_6_199: `lễ hội té nước vui vẻ`,
	str_6_CH03: `bodin`,
	str_6_208: `cây tiền`,
	str_6_207: `Thái sic BO`,
	str_6_209: `thần tình yêu bé nhỏ`,
	str_6_5: `vàng lớn`,
	str_6_12: `Nhà vàng ngọc đầy nhà`,
	str_6_16: `Ngũ hành`,
	str_6_36: `trùm câu lạc bộ đêm`,
	str_6_58: `Con gà trống vàng 2`,
	str_6_64: `Thần Zeus`,
	str_6_205: `khiêu vũ`,
	str_6_81: `Đảo kho báu`,
	str_6_AS08: `Vàng Maya`,
	str_6_AS09: `vật nuôi hollywood`,
	str_6_AS10: `3 may mắn`,
	str_6_AS17: `Kho báu của Seth`,
	str_6_AS18: `Kẹo cao su điên`,
	str_6_AS19: `câu chuyện giáng sinh`,
	str_6_AS20: `nữ hoàng chết chóc`,
	str_6_99: `nhảy cao hơn`,
	str_6_103: `ghép đá quý`,
	str_6_102: `tiệc trái cây`,
	str_6_118: `tài xế cũ`,
	str_6_130: `trộm vàng cô gái`,
	str_6_135: `Chú gà trống vàng thẳng thắn An Truyền tin`,
	str_6_136: `con thú chạy`,
	str_6_137: `vũ điệu thẳng`,
	str_6_138: `nhảy qua`,
	str_6_139: `Thuyền dây chuyền cháy thẳng`,
	str_6_140: `Đốt xích tàu 2`,
	str_6_141: `giáng sinh đến rồi`,
	str_6_142: `Vulcan`,
	str_6_143: `Fortune Fuwa`,
	str_6_144: `khoan để biết thêm`,
	str_6_AT01: `Một shot của câu cá`,
	str_6_112: `Cướp lăng mộ của pharaoh`,
	str_6_152: `bay đôi`,
	str_6_153: `sáu đường`,
	str_6_154: `Cha của Zeus`,
	str_6_160: `thần tài2`,
	str_6_163: `Nezha đến một lần nữa`,
	str_6_161: `Nhân vật`,
	str_6_173: `666`,
	str_6_183: `Chó sói, sói disco`,
	str_6_CA01: `Yaxing CQ9 Trực tiếp`,
	str_6_4: `Thái hậu rừng`,
	str_6_9: `Zhong Kui Vận may May mắn`,
	str_6_13: `Cô gái sakura`,
	str_6_17: `Sư tử may mắn`,
	str_6_201: `võ sĩ quyền anh`,
	str_6_203: `phấn khích lên`,
	str_6_79: `tắc kè hoa`,
	str_6_89: `Thor`,
	str_6_AS01: `ủng may mắn`,
	str_6_AS02: `xiếc điên`,
	str_6_AS03: `cách huấn luyện rồng`,
	str_6_121: `nhảy thẳng lên 2`,
	str_6_124: `Khóa voi bất khả chiến bại`,
	str_6_125: `Zeus thẳng`,
	str_6_127: `Straight Wusheng`,
	str_6_128: `kiếm tiền lớn`,
	str_6_129: `Chú gà trống vàng thẳng thắn An Truyền tin 2`,
	str_6_133: `Straight Hongfu Qitian`,
	str_6_AS33: `may mắn của con lợn`,
	str_6_3: `nụ hôn của máu`,
	str_6_7: `để nhảy lên`,
	str_6_15: `Truyền tin của Gà trống vàng`,
	str_6_19: `Bánh xe nóng`,
	str_6_20: `Fafafa`,
	str_6_21: `Truyền thuyết về con sói hoang dã`,
	str_6_22: `Đại cương bài học Tây du ký 2`,
	str_6_23: `Vàng miếng`,
	str_6_24: `để nhảy lên2`,
	str_6_26: `777`,
	str_6_27: `thê giơi phep thuật`,
	str_6_29: `thế giới nước`,
	str_6_31: `Wu Sheng`,
	str_6_32: `Detective Di Renjie`,
	str_6_33: `Đốt xích tàu `,
	str_6_34: `Trận chiến Gopher`,
	str_6_38: `Chỉ cần nhảy`,
	str_6_42: `Holmes`,
	str_6_44: `Deluxe trái cây King`,
	str_6_46: `mặt trăng sói`,
	str_6_47: `Kho báu Pharaoh`,
	str_6_49: `Hành tinh cô đơn`,
	str_6_50: `Hồng Phúc Qitian`,
	str_6_51: `chào vụ nổ lớn gánh xiếc`,
	str_6_52: `nhảy cao`,
	str_6_202: `cô gái nhảy`,
	str_6_67: `Kiếm quả trứng vàng `,
	str_6_AB3: `Trang trại câu cá vàng`,
	str_6_59: `đười ươi mùa hè`,
	str_6_180: `Truyền tin của Gà trống vàng3`,
	str_6_179: `nhảy cao2`,
	str_6_GO169: `Quả cầu thép nhỏ Lucky Dragon`,
	str_6_185: `Ngọc rồng`,
	str_6_186: `nữ hoàng lửa2`,
	str_6_195: `Voi giàu có`,
	str_6_196: `Niềm vui gấp mười lần vàng`,
	str_6_200: `chạy đi alice`,
	str_6_AS04: `Wealth Spectre`,
	str_6_108: `nhảy thẳng lên cao hơn`,
	str_6_109: `nhảy lên bằng một tay`,
	str_6_111: `bay lên`,
	str_6_115: `nữ hoàng băng`,
	str_6_116: `thần tiên mộng du`,
	str_6_117: `TVXQ`,
	str_6_221: `Bốn vị thiên vương của Di Renjie`,
	str_6_123: `Ngũ phúc đến thẳng cửa`,
	str_6_132: `thêm một tiếng meo`,
	str_6_AT05: `câu cá vui vẻ`,
	str_6_184: `sáu viên`,
	str_6_BT02: `Lấy Zhuang Dice Niu Niu`,
	str_6_187: `Vịnh Xuân Quyền`,
	str_6_188: `Cricket Mania`,
	str_6_194: `rồng bay trên bầu trời`,
	str_6_BT03: `Lấy Zhuang Mi Niu Niu`,
	str_6_AT101: `Mercedes-Benz BMW`,
	str_6_5007: `làm cho một tài`,
	str_6_5008: `lớn màu đỏ`,
	str_6_5009: `sự tàn phá trên thiên đường`,
	str_6_206: `crit ngọt ngào`,
	str_6_210: `Woo ga sợ hãi`,
	str_6_212: `Hành trình nóng bỏng về phía Tây`,
	str_6_213: `Roulette nhỏ`,
	str_6_214: `gấu mèo ninja`,
	str_6_GO01: `máy đẩy đồng tiền ngọc rồng`,
	str_6_GB1: `321 ra mắt`,
	str_6_GB198: `Bingo màu khỉ`,
	str_6_215: `nóng và cay`,
	str_6_211: `Aquaman`,
	str_6_GB2: `kẻ săn quái vật`,
	str_6_216: `đĩa màu`,
	str_6_217: `Đĩa trái cây mạt chược`,
	str_6_177: `cậu bé và cây đèn thần`,
	str_6_GB6: `Thần Voi nhỏ giàu có`,
	str_6_218: `达拉崩吧`,
	str_6_219: `Khỉ đột vàng đặc biệt`,
	str_6_220: `This market is dead`,
	str_6_222: `Nước cầu nguyện Thần Thái`,
	str_6_GB3: `biến tiền vàng`,
	str_7_0: `sảnh`,
	str_7_620: `Texas Hold’em`,
	str_7_720: `28 thanh`,
	str_7_830: `Nắm lấy Zhuang Niu Niu`,
	str_7_220: `hoa chiên vàng`,
	str_7_860: `Sangong`,
	str_7_900: `Betzhuang Rồng hổ`,
	str_7_600: `21 giờ`,
	str_7_870: `Tumblr Nữu Nữu`,
	str_7_230: `Bông hoa vàng chiên nhanh`,
	str_7_730: `Lấy Pai Gow của chủ ngân hàng`,
	str_7_630: `13 vùng nước`,
	str_7_610: `Chiến đấu với Landlord`,
	str_7_910: `Bài Baccarat`,
	str_7_920: `bóng rừng`,
	str_7_930: `Trăm người gia súc`,
	str_7_1950: `10.000 người chiên hoa vàng`,
	str_7_650: `sông máu`,
	str_7_890: `Xem các thẻ và lấy Zhuang Niuniu`,
	str_7_740: `Mạt chược cho hai người`,
	str_7_1350: `Wheel of Fortune (không thể truy cập riêng)`,
	str_7_1940: `cá mập vàng cá mập bạc`,
	str_7_1960: `Mercedes-Benz BMW`,
	str_7_1980: `100 Tài Xỉu`,
	str_7_1810: `one-on-oh Niu Niu`,
	str_7_1990: `NI U xào`,
	str_7_1850: `Đặt cược để cướp Zhuang Niuniu`,
	str_7_510: `câu cá phong bì đỏ`,
	str_7_1355: `Hãy thử (không thể truy cập riêng)`,
	str_7_1970: `Năm sao Honghui`,
	str_7_1860: `bài xì phé casino`,
	str_7_1370: `Stud Hồng Kông`,
	str_7_1690: `Sic Bo đẫm máu`,
	str_7_1890: `máy hoa quả`,
	str_7_1610: `Kho báu May mắn (không thể truy cập riêng)`,
	str_7_1930: `Cá tôm, cua`,
	str_7_8130: `chạy nhanh`,
	str_7_950: `chiến tranh đỏ đen`,
	str_7_840: `Điên cuồng nắm lấy Zhuang Niu Niu`,
	str_7_1710: `Câu đố chiến tranh ngựa (không thể truy cập riêng)`,
	str_7_520: `Li Kui câu cá`,
	str_9_MX_LIVE_001: `Baccarat cổ điển`,
	str_9_MX_LIVE_002: `Bài Baccarat`,
	str_9_MX_LIVE_0039: `9_MX_LIVE_003 bảo hiểm Baccarat`,
	str_9_MX_LIVE_006: `Rồng hổ`,
	str_9_MX_LIVE_007: `Tài Xỉu`,
	str_9_MX_LIVE_009: `Trò chơi Roulette`,
	str_9_MX_LIVE_010: `xúc xắc đỏ và xanh`,
	str_10_1: `Bài Baccarat`,
	str_10_3: `Rồng hổ`,
	str_10_4: `Trò chơi Roulette`,
	str_10_5: `Tài Xỉu`,
	str_10_7: `การสู้วัวกระทิง`,
	str_10_6: `Fan Tan`,
	str_10_8: `thi Baccarat`,
	str_10_11: `hoa chiên vàng`,
	str_10_12: `Tài Xỉu tốc độ`,
	str_10_14: `đĩa màu`,
	str_10_15: `Cá, tôm và cua`,
	str_10_51: `Trực tiếp may mắn 5`,
	str_10_52: `Trực tiếp may mắn 10`,
	str_12_0: `sảnh`,
	str_12_620: `Texas Hold’em`,
	str_12_720: `28 thanh`,
	str_12_830: `Nắm lấy Zhuang Niu Niu`,
	str_12_220: `hoa chiên vàng`,
	str_12_860: `Sangong`,
	str_12_900: `Rồng và Hổ chiến đấu`,
	str_12_600: `21 giờ`,
	str_12_870: `Tumblr Nữu Nữu`,
	str_12_230: `Bông hoa vàng chiên nhanh`,
	str_12_730: `Lấy Pai Gow của chủ ngân hàng`,
	str_12_630: `13 vùng nước`,
	str_12_610: `Chiến đấu với Landlord`,
	str_12_890: `nhìn ba Grab Zhuang Niu Niu`,
	str_12_910: `Bài Baccarat`,
	str_12_950: `chiến tranh đỏ đen`,
	str_12_740: `Mạt chược cho hai người`,
	str_12_930: `Trăm người gia súc`,
	str_12_510: `trận đánh cá`,
	str_12_8120: `trận chiến đẫm máu`,
	str_12_920: `bóng rừng`,
	str_12_8150: `nhìn bốn Grab Zhuang Niu Niu`,
	str_12_8180: `Phù hợp với viên ngọc`,
	str_12_8160: `癞子牛牛`,
	str_12_8210: `Hãy thử `,
	str_12_8130: `chạy nhanh`,
	str_12_8200: `Lấy nhân viên ngân hàng và chọn ba`,
	str_12_8190: `Mười nghìn người đẩy suốt chỉ`,
	str_12_8220: `lấy một phong bì màu đỏ`,
	str_12_8230: `Triệu bao lì xì`,
	str_12_940: `cá mập vàng cá mập bạc`,
	str_12_8260: `người chơi số một`,
	str_12_8270: `Chúc mừng hoa chiên vàng`,
	str_12_8280: `Phòng riêng bạn bè 8281`,
	str_12_8281: `ạn bè lấy gói màu đỏ Grab Zhuang Niu Niu`,
	str_12_8250: `drift xe sang trọng`,
	str_12_8110: `sông máu`,
	str_12_8310: `Thần tài đến`,
	str_12_8140: `máy hoa quả`,
	str_12_8340: `mười giờ rưỡi`,
	str_12_8320: `Ô vuông đen đỏ mận 8330`,
	str_12_8330: `đua tốc độ`,
	str_12_8410: `bài xì phé casino`,
	str_12_8450: `Tài Xỉu Grab Zhuang Niu Niu`,
	str_12_8460: `Tài Xỉu cướp được của Zhuang Sangong`,
	str_12_8470: `Xí ngầu Tongbi Sangong`,
	str_12_8480: `Tài Xỉu màu đỏ và đen đơn và đôi`,
	str_12_8490: `Tài Xỉu trận chiến đẫm máu`,
	str_12_8500: `Big Talk Dice 067`,
	str_12_8510: `chai xúc xắc lớn nói chuyện`,
	str_12_8360: `con khỉ kỳ lạ`,
	str_12_8440: `Stud Hồng Kông`,
	str_12_8420: `Shangzhuang Trăm người gia súc`,
	str_12_8282: `Phòng bạn bè Texas Hold'em`,
	str_12_8550: `NI U xào`,
	str_12_8600: `lật đổ Hu`,
	str_12_8640: `Tài Xỉu nhiều người chơi`,
	str_12_8231: `phong bao lì xì`,
	str_12_8680: `hai người Niu Niu`,
	str_12_8620: `Dice Niu Niu`,
	str_12_8630: `nhìn trong tuyệt vọng`,
	str_12_8650: `Phiên bản thi đấu Grab Zhuang Niu Niu`,
	str_12_8690: `Trăm người rán vàng`,
	str_12_8660: `Roulette Châu Âu`,
	str_12_8750: `Stud cổ điển`,
	str_12_8740: `Dou Jinhua`,
	str_12_8820: `câu cá vui vẻ`,
	str_12_8730: `Nhảy qua Cổng Rồng`,
	str_12_8810: `chiến tranh sòng bạc`,
	str_12_8700: `100 bàn tay Texas Hold'em`,
	str_12_8720: `Hàng trăm người bắn vào giàn`,
	str_8_3001: `Bài Baccarat`,
	str_8_3003: `Rồng và Hổ chiến đấu`,
	str_8_3005: `Sangong`,
	str_8_3006: `Ôn Châu Pai Gow`,
	str_8_3007: `Trò chơi Roulette`,
	str_8_3008: `Tài Xỉu`,
	str_8_3011: `đĩa màu`,
	str_8_3012: `Niu Niu`,
	str_8_3015: `Fan Tan`,
	str_8_3016: `Cá, tôm và cua`,
	str_8_3017: `bảo hiểm Baccarat`,
	str_8_3018: `hoa chiên vàng`,
	str_8_3021: `ChàoLo`,
	str_8_3025: `Baccarat trong chuỗi khối`,
	str_8_3026: `Cuộc chiến giữa Rồng và Hổ trong Blockchain`,
	str_8_3027: `Bảo hiểm Blockchain Baccarat`,
	str_8_3028: `Cò quay trên Blockchain`,
	str_8_3029: `Blockchain hoa vàng chiên`,
	str_8_3030: `Blockchain ba công khai`,
	str_8_3031: `con bò đực của blockchain`,
	str_8_3032: `Đĩa màu blockchain`,
	str_8_3033: `Tài Xỉu trong Blockchain`,
	str_8_3034: `Blockchain cá, tôm và cua`,
	str_8_3036: `BlockchainHiLo`,
	str_8_3037: `Blockchain Fan Tan`,
	str_8_3038: `Chuỗi khối Ôn Châu Pai Gow`,
	str_8_3039: `Blockchain cá, tôm, cua của Việt Nam`,
	str_8_3043: `Trò chơi Baccarat Blackjack Blockchain`,
	str_8_3045: `Blockchain cá, tôm và cua Thái Lan`,
	str_8_3047: `Bài xì dách Baccarat`,
	str_8_109001: `bóng đá`,
	str_8_109002: `bóng rổ`,
	str_8_109003: `Bóng bầu dục Mỹ`,
	str_8_109004: `quần vợt`,
	str_8_109005: `bóng chày`,
	str_8_109006: `khúc côn cầu trên băng`,
	str_8_109007: `bóng chuyền`,
	str_8_109008: `Thể thao điện tử`,
	str_8_109009: `cầu lông`,
	str_8_109010: `Bida / Snooker`,
	str_8_109012: `Võ tổng hợp`,
	str_8_109013: `bóng bàn`,
	str_8_109014: `bóng bầu dục`,
	str_8_109017: `bóng ném`,
	str_8_109018: `Khúc côn cầu trên bãi cỏ`,
	str_8_109019: `đua xe`,
	str_8_109020: `gôn`,
	str_8_109023: `Phi tiêu`,
	str_8_109025: `môn bóng nước`,
	str_8_109029: `bóng chày`,
	str_8_109040: `bóng lưới`,
	str_8_109051: `Bóng chuyền bãi biển`,
	str_8_109065: `bóng đá bãi biển`,
	str_8_109082: `CS GO`,
	str_8_109083: `Dota 2`,
	str_8_109084: `Liên Minh Huyền Thoại`,
	str_8_109132: `bóng đá thể thao điện tử`,
	str_8_109133: `bóng rổ thể thao điện tử`,
	str_8_109147: `vua của vinh quang`,
	str_8_109159: `quần vợt thể thao điện tử`,
	str_8_109160: `khúc côn cầu trên băng eSports`,
	str_8_109161: `bóng chuyền thể thao điện tử`,
	str_8_109998: `hỗn hợp vượt qua`,
	str_8_5005: `Chiến tranh giữa các vì sao`,
	str_8_5006: `Staronic`,
	str_8_5008: `khỉ leo cây`,
	str_8_5009: `King Kong leo cầu thang`,
	str_8_5010: `Cuộc chiến người ngoài hành tinh`,
	str_8_5012: `Cuộc chinh phục người ngoài hành tinh`,
	str_8_5013: `Phong tục`,
	str_8_5014: `rừng`,
	str_8_5015: `FIFA2010`,
	str_8_5019: `Thiên đường trái cây`,
	str_8_5027: `Kung Fu Dragon`,
	str_8_5030: `Thần tài may mắn`,
	str_8_5039: `Cá, tôm và cua`,
	str_8_5043: `bát trái cây kim cương`,
	str_8_5044: `Ngôi sao 97II`,
	str_8_5045: `bóng rừng`,
	str_8_5046: `Linh hồn chiến đấu`,
	str_8_5054: `Craps`,
	str_8_5057: `ngôi sao 97`,
	str_8_5058: `Bát trái cây điên điển`,
	str_8_5061: `siêu 7`,
	str_8_5062: `Rồng đang trên đường`,
	str_8_5063: `Xèng hoa quả`,
	str_8_5064: `Slots bài xì phé`,
	str_8_5065: `筒子拉霸`,
	str_8_5066: `Slots bóng đá`,
	str_8_5067: `Hành trình về phía Tây`,
	str_8_5068: `Cool So Circus`,
	str_8_5069: `Đấu trường trái cây`,
	str_8_5076: `bánh xe kỹ thuật số`,
	str_8_5077: `bánh xe trái cây`,
	str_8_5079: `3D bánh xe kỹ thuật số`,
	str_8_5080: `Bánh xe xổ số`,
	str_8_5083: `tàu kim cương`,
	str_8_5084: `Truyền thuyết về Thánh thú`,
	str_8_5088: `Dou Đà`,
	str_8_5089: `chó đỏ`,
	str_8_5090: `Truyền tin của Gà trống vàng`,
	str_8_5093: `Jin Bình Mei`,
	str_8_5094: `Jin Bình Mei 2`,
	str_8_5095: `chọi gà`,
	str_8_5096: `Ngũ hành`,
	str_8_5097: `Thế giới dưới nước`,
	str_8_5098: `Ngũ phúc đến tận cửa`,
	str_8_5099: `Con chó vàng hạnh phúc`,
	str_8_5100: `Tanabata`,
	str_8_5105: `Roulette Châu Âu`,
	str_8_5106: `ba quốc gia`,
	str_8_5107: `Roulette kiểu Mỹ`,
	str_8_5108: `Roulette thưởng`,
	str_8_5109: `Cò quay kiểu Pháp`,
	str_8_5110: `đêm thượng hải`,
	str_8_5119: `Hòn đảo bí ẩn`,
	str_8_5120: `Nữ Oa sửa bầu trời`,
	str_8_5121: `Olympus`,
	str_8_5122: `cuộc chiến bóng`,
	str_8_5123: `Xì dách cổ điển`,
	str_8_5124: `Tây Ban Nha 21 giờ`,
	str_8_5125: `Xì dách Vegas`,
	str_8_5126: `Thưởng 21 điểm`,
	str_8_5127: `PUBG Mobile 5128`,
	str_8_5128: `nhiều tài sản và sự giàu có`,
	str_8_5138: `kẹp hạt lợn`,
	str_8_5139: `Thiên đường gấu trúc`,
	str_8_5140: `lễ hội bia`,
	str_8_5141: `người chiến thắng trận đấu bò`,
	str_8_5142: `Ánh sáng ma thuật và âm thanh ảo`,
	str_8_5143: `Bữa tiệc kẹo 3`,
	str_8_5144: `Đêm tình nhân`,
	str_8_5145: `từng bước cao lên`,
	str_8_5146: `Bữa tiệc kẹo`,
	str_8_5150: `huyền thoại đá quý`,
	str_8_5151: `Jenga`,
	str_8_5152: `huyền thoại ai cập`,
	str_8_5153: `Cáo chín đuôi`,
	str_8_5154: `Cuộc tấn công Hatsune`,
	str_8_5155: `Cung điện rồng biển Đông Trung Hoa`,
	str_8_5156: `Đế chế Zuma`,
	str_8_5157: `Ba nhân dân tệ và bốn niềm vui`,
	str_8_5159: `Max điên`,
	str_8_5160: `Thần sấm`,
	str_8_5162: `quả trứng vui vẻ`,
	str_8_5163: `Sói mặt trăng`,
	str_8_5164: `những điều tốt đẹp đi đôi với nhau`,
	str_8_5165: `thần chiến tranh`,
	str_8_5166: `bầu bí`,
	str_8_5167: `ngựa để thành công`,
	str_8_5168: `Bản tin Gà trống Vàng 2020`,
	str_8_5169: `Tiếng nói của Trung Quốc`,
	str_8_5170: `Huyền thoại dưới đáy biển`,
	str_8_5171: `Candy Party _ Phiên bản Tốc độ`,
	str_8_5172: `Thần giàu có một phần`,
	str_8_5173: `vận may`,
	str_8_5174: `Ông hoàng nhạc điện tử`,
	str_8_5175: `Gypsophila`,
	str_8_5176: `các quốc gia tham chiến man rợ`,
	str_8_5177: `bông sen`,
	str_8_5178: `vương quốc hơi nước`,
	str_8_5181: `Li Li`,
	str_8_5182: `Douyin DJ`,
	str_8_5183: `Qian Kun ngược`,
	str_8_5184: `Nhảy qua Cổng Rồng`,
	str_8_5185: `thu hoạch lớn`,
	str_8_5186: `Thông báo về Bảy vận may`,
	str_8_5187: `bậc thầy ninja`,
	str_8_5188: `Năm mới vui vẻ`,
	str_8_5189: `bò may mắn`,
	str_8_5191: `đầy lợn`,
	str_8_5192: `thế giới băng giá`,
	str_8_5193: `thanh kẹo`,
	str_8_5194: `thần tài lộc vàng`,
	str_8_5195: `ong chiến thắng hoang dã`,
	str_8_5197: `bữa tiệc quái vật`,
	str_8_5198: `Thần thoại hạ long`,
	str_8_5199: `thức ăn đường phố`,
	str_8_5200: `Cá, tôm, cua được mở`,
	str_8_5204: `2014 FIFA`,
	str_8_5205: `công viên bom`,
	str_8_5206: `Nỏ rùa vàng`,
	str_8_5207: `Wuson đánh bại một con hổ`,
	str_8_5208: `Trò chơi lô tô`,
	str_8_5209: `Thảo nguyên Pat`,
	str_8_5210: `Candy Fun`,
	str_8_5211: `doofo Thần của sự giàu có`,
	str_8_5212: `Nezha`,
	str_8_5214: `Ninja trái cây`,
	str_8_5215: `chơi tối nay`,
	str_8_5216: `Kho báu nàng tiên cá`,
	str_8_5217: `Trái cây Lucky Star`,
	str_8_5218: `cuộc phiêu lưu trong rừng`,
	str_8_5402: `cuộc sống chợ đêm`,
	str_8_5404: `Bóng chuyền bãi biển`,
	str_8_5407: `Cô bé quàng khăn đỏ và con sói nhỏ`,
	str_8_5601: `Cuộc phiêu lưu chưa được khám phá`,
	str_8_5803: `Kho báu Aztec`,
	str_8_5805: `Đế chế Caesar 5810`,
	str_8_5810: `Thời đại của Điều hướng`,
	str_8_5823: `làm cho một tài`,
	str_8_5824: `Truyền thuyết về rồng ác`,
	str_8_5828: `Khủng long bạo chúa Rex`,
	str_8_5835: `Chúc mừng năm Sửu`,
	str_8_5837: `Chúc mừng năm Bính Thân`,
	str_8_5839: `Bóng cao cổ điển 5901`,
	str_8_5901: `truy tìm kho báu nối tiếp`,
	str_8_5902: `Bữa tiệc kẹo`,
	str_8_5903: `Kho báu bí mật của Hoàng đế Tần 5904`,
	str_8_5904: `Bom hơi nước 5908`,
	str_8_5908: `Bữa tiệc kẹo 2`,
	str_8_5909: `Xiao Xiaole hạnh phúc`,
	str_8_5910: `yếu tố ma thuật`,
	str_8_5912: `Kho báu nối tiếp 2`,
	str_8_5888: `JACKPOT`,
	str_8_30599: `chuyên gia câu cá `,
	str_8_30598: `chuyên gia câu cá 2`,
	str_8_30593: `cậu bé vàng câu cá`,
	str_8_38001: `bậc thầy câu cá`,
	str_8_38002: `trang trại cá phong phú`,
	str_3_kxyznmbpret1y: `khu rừng mê hoặc`,
	str_3_qd1fcneqbhgy4: `Hentai`,
	str_3_kdn8ckjqfhsn4: `Lăng mộ của Pharaoh`,
	str_3_d4fyes4amfxf6: `Phượng Hoàng`,
	str_3_a7q65cfts455e: `quyền anh 2`,
	str_3_cuarr8e1ncebn: `trái cây nhiệt đới`,
	str_3_96k1k6d3x39za: `Cuộc phiêu lưu trong rừng`,
	str_3_x5ikj69a989x6: `thợ săn vàng`,
	str_3_c85wq8o9doqtr: `thầy phù thủy`,
	str_3_hb4cpgc6u6qj4: `thần thoại phương tây`,
	str_3_wr5axzs95uq7r: `Kho báu rừng`,
	str_3_cd4rcge6dhqb4: `Ngày của người chết`,
	str_3_exesnxb7ge3uy: `ngôi nhà ma ám`,
	str_3_pd6rhresnhkbk: `Thiếu lâm`,
	str_3_ezjsgctugyauc: `Big Fortune Bingo`,
	str_3_fn6yhwksk7kfk: `Bingo thợ săn ớt`,
	str_3_nqyun5dpcjtsy: `cạnh tranh trực tuyến`,
	str_3_uafejs6a58xp6: `Thợ săn tiền thưởng`,
	str_3_jzpssktmfyw1h: `mười hai chòm sao`,
	str_3_7b6c7rcs16kjk: `đại dương phun`,
	str_3_uwf5zss55dc7h: `Ye Xian`,
	str_3_3fx69pizs144w: `vệt may mắn`,
	str_3_6o5emdcnoqyen: `Đền Aztec`,
	str_3_5cx47jffukp3o: `Ví tám kho báu`,
	str_3_gqotnunpejbwy: `Lễ hội may mắn`,
	str_3_b1cnw7mkppwg1: `Kẻ sát nhân`,
	str_3_6c5apdrpokbay: `Thần của sự giàu có thịnh vượng`,
	str_3_ipz77igi3mfho: `mùa đông ngọt ngào`,
	str_3_b5ggg45epfzg6: `siêu hành tinh`,
	str_3_93ine65axf986: `quyền anh `,
	str_3_4eekxm7cistkg: `Miền của Rồng`,
	str_3_y5n8sh5oqf58q: `hổ den`,
	str_3_r8oiyz19mtqir: `chú hề may mắn`,
	str_3_ha1jzrho1gmjq: `Đá quý của người Maya`,
	str_3_3erm9p7wssiks: `ngọn lửa của định mệnh`,
	str_3_ofy9b9z99u69r: `Đế chế rồng`,
	str_3_swt38osdadyhc: `Pirate Saga`,
	str_3_gkubyu4cjibrg: `chú hề điên`,
	str_3_rqaonzn7kjjiy: `Bốn phát minh vĩ đại`,
	str_3_m94wkgy3daxta: ` Cát huyền bí`,
	str_3_tocki7xk7xwq1: `flame pearl bingo`,
	str_3_cz3wgrounyetc: `Aquaman Bingo`,
	str_3_z7k6mqf3z495a: `Crypto Mania Bingo`,
	str_3_fqho1inijjfwo: `Vua rồng biển Đông`,
	str_3_8kzbot4rew7ds: `Tây du ký`,
	str_3_gsttgo1debywc: `Đá quý bát giác 2`,
	str_3_quofrdenycyyn: `chuyện phiếm 2`,
	str_3_1wt58azdhdo6c: `Cổ tích tất cả phù hợp`,
	str_3_n1ydr5mncpogn: `Thợ săn ớt`,
	str_3_gn1bc1kqj7gr4: `chuyện phiếm `,
	str_3_dxxsh3dfmjpio: `Lao Jun quá cao`,
	str_3_9ii7s6u5xbhzh: `cây thế giới`,
	str_3_wcaadzg74mj7y: `Đại bàng phu nhân`,
	str_3_s77hiogba5dhe: `Câu lạc bộ Peach`,
	str_3_bzgza4umpbwsh: `Truyền thuyết về ba hoàng tử`,
	str_3_bmr8675wqiigs: `phù thủy đáng yêu`,
	str_3_oajk3h9o685xq: `nhà kho`,
	str_3_ur8593z8hu17w: `ngọc trai cháy`,
	str_3_j9nzkkbjfaz1a: `Con mắt của thần Horus`,
	str_3_1ru5x5zx7us6r: `Thần sét`,
	str_3_5ii9zgw5unc3h: `Kho báu của Aquaman`,
	str_3_wykepsq659qp4: `bốn con rồng`,
	str_3_q9gi4yybyadoe: `gấu trúc hoang dã`,
	str_3_dkzdo35rcipfs: `Trung Quốc`,
	str_3_ie9eti6w4zfcs: `hiện vật cổ đại`,
	str_3_7cz37fritkfao: `gà may mắn`,
	str_3_84igeq3a8r9d6: `Thợ săn Nugget`,
	str_3_4tyxfmpnwqokn: `Đá quý bát giác `,
	str_3_soojfuqnaxycn: `mùa hè hoa quả`,
	str_3_rsjogw1ukbeic: `Tứ hổ châu Á`,
	str_3_3yfmucpss64mk: `Ngọn lửa rồng`,
	str_3_o7f9ih8t6559e: `Wu Zetian`,
	str_3_wtupmzq14xepn: `múa sư tử`,
	str_3_d8cso3u8ct1iw: `Phượng hoàng tái sinh 888`,
	str_3_7tccifcktqre1: `tài phiệt lớn`,
	str_3_4akkze7ywgukq: `hưng cảm tiền điện tử`,
	str_3_86burqb38a9ua: `Bushido`,
	str_3_8u9r4tj48chd1: `vua đặt bom`,
	str_3_zygj7oqga9nck: `Thần tài`,
	str_3_srd3xusx3ughr: `Nhập KTV`,
	str_3_5ypkuepgw61kk: `Năm yếu tố của nước gửi những lời chúc phúc`,
	str_3_yxdzc9d7qj3zy: `Ngũ hành của lửa gửi phước lành`,
	str_3_g8awyu1xjtgwr: `crit lửa đỏ`,
	str_3_e4ndsc3ogr5dq: `Rồng lửa 88`,
	str_3_m1xn4je4dccb1: `đá quý cổ xưa`,
	str_3_qn3ynneqbhgy4: `Ba con hổ thống trị`,
	str_3_kqm1cmbpret1y: `trang sức chú hề`,
	str_3_knjnnkjqfhsn4: `Chương 888 truyền thuyết về rồng`,
	str_3_d5qfgs4amfxf6: `vòng quay điên cuồng`,
	str_3_ahf5icfts455e: `Jinfu may mắn`,
	str_3_c41bsraonrmbq: `Xuanpu Gala`,
	str_3_99bzr6d3x39za: `Bạn thuộc về gì`,
	str_3_x46x869a989x6: `Thần tài`,
	str_3_kk8nqm3cfwtng: `Haiba`,
	str_3_xkhy6baryz7xs: `Aquaman 2 Ex _ Sơ cấp`,
	str_3_qq5ocdypyeboy: `Aquaman 2 Ex _ Người mới bắt đầu`,
	str_3_g54rso4yefdrq: `Aquaman 2 Ex _ Chuyên gia`,
	str_3_ary5bxi9z165r: `Aquaman 2 Ex _ Những người bạn`,
	str_3_b8rzo7uzqt4sw: `Cóc vàng`,
	str_3_8d7r1okge7nrk: `Dasheng Naohai`,
	str_3_nzkseaudcbosc: `Li Kui tách cá`,
	str_3_wi17jwsu4de7c: `bò tiền mặt`,
	str_3_1jeqx59c7ztqg: `Aquaman 3`,
	str_3_4omkmmpnwqokn: `Hình vuông SpongeBob`,
	str_3_st5cmuqnaxycn: `câu cá vui vẻ 5`,
	str_3_ddpg1amgc71gk: `Bug Paradise`,
	str_3_p63ornyjba8oa: `Bến ngư phủ`,
	str_3_xq9ohbyf9m79o: `Vua chim chiến đấu vì sóc bay và bầu trời hoàng gia`,
	str_3_hcu3p8r71kj3y: `Siêu sao`,
	str_3_hf5hx8w9u1q3r: `Sách Giao ước Phiên bản Deluxe`,
	str_3_43bx3e7ywgukq: `Phiên bản Dolphin's Pearl Deluxe`,
	str_3_ateqfxp1sqamn: `Kho báu cá heo`,
	str_3_fk9yoi4wkifrs: `50 Sư tử vàng`,
	str_3_ww3a8wsu4de7c: `trái cây mùa hè`,
	str_3_8nsbhokge7nrk: `nữ hoàng của sông nile`,
	str_3_qxoindypyeboy: `geisha`,
	str_3_xmzfobaryz7xs: `vua biển cả`,
	str_3_7f9h9fwz11kaw: `Phiên bản sang trọng Lady Luck Amulet`,
	str_3_ioheiiqk3xrc1: `Sách của các giao ước`,
	str_3_k9gz4ebbrau1e: `rồng đôi vàng`,
	str_3_aij68ciusna5c: `Columbus`,
	str_3_satj3o6ya8dcq: `Trang sức tối cao`,
	str_3_5m6k9j7rwspjs: `Đấu trường La Mã`,
	str_3_igg7tisz4ukhw: `Cleopatra`,
	str_3_w4ypzw6o48mpq: `Rồng và Phượng`,
	str_3_xbxy1yegyhnyk: `Cuộc phiêu lưu trên Đảo Rừng`,
	str_3_foff4ikkjprr1: `Thủy hử`,
	str_3_ef1uyxt98o6ur: `Thần tài`,
	str_3_naagsa5ycfugq: `Ai Cập cổ đại`,
	str_3_i4rc816e388c6: `Robin Hood`,
	str_3_nh9swadbc3use: `Liên kết Crown tốc độ cao`,
	str_3_tqi9778i7mi6o: `Miami`,
	str_3_byz81hmsq748k: `Thần tối cao của sự giàu có`,
	str_3_ruufkzk1kpefn: `kết nối đạn bạc`,
	str_3_awn5jciusna5c: `Chiến lợi phẩm Captain Connect`,
	str_3_3hj4fkfji4z4a: `Thần may mắn Fafafa 2`,
	str_3_u17q53q45xcp1: `Truyền thuyết về con rắn trắng`,
	str_3_kia1eetdryo1c: `Alice`,
	str_3_9xpa7brfxj7zo: `Mamma Mia`,
	str_3_pirtanombyroh: `thế giới man rợ`,
	str_3_ne4gq55cpitgg: `hạt đậu thần`,
	str_3_k3anse3yrrunq: `cảnh sát trưởng miền tây`,
	str_3_79mafnrjt48aa: `Pan Kim Liên`,
	str_3_fwria11mjbrwh: `Bá chủ tam quốc`,
	str_3_dc7sh3dfmjpio: `Dragon Tiger`,
	str_3_3uim5ppkiqwk1: `Cá, tôm và cua`,
	str_3_j3wngk3efrzn6: `Bài Baccarat`,
	str_3_yr1zy9u9xt6zr: `quả bầu`,
	str_3_hxb3p8r71kj3y: `Tài Xỉu`,
	str_3_8rqwot18etnuw: `Thor`,
	str_3_9upe5bm4xph81: `Vua khỉ`,
	str_3_113qm5xnhxoqn: `Đèn của Aladdin`,
	str_3_ywozehuuqbazc: `đảo vàng`,
	str_3_bcizh7dipjiso: `Hua Mulan`,
	str_3_55hj8ghaugxj6: `Nụ cười Di Lặc`,
	str_3_jpiuhpbifei1o: `Truyền tin của Gà trống vàng`,
	str_3_itzp5iqk3xrc1: `tinh thần hoang dã`,
	str_3_7rw3tfwz11kaw: `Kho báu bắc cực`,
	str_3_aodmmxp1sqamn: `vận may`,
	str_3_o3nxzh9o685xq: `rồng bay trên bầu trời`,
	str_3_ufc6t3z8hu17w: `giáng sinh bất ngờ`,
	str_3_j6j1rkbjfaz1a: `Ngũ hổ tướng`,
	str_3_9w6aa6u5xbhzh: `tóc rồng vàng`,
	str_3_wpu7pzg74mj7y: `trống tốt lành làm cho một tài sản`,
	str_3_tbfxuhxs694xk: `Fortune Panda`,
	str_3_gd3rn1kqj7gr4: `nữ hoàng`,
	str_3_wfo7bzs95uq7r: `Cung thủ`,
	str_3_jsguaktmfyw1h: `Nhân vật`,
	str_3_dhdirsn3m3xia: `Thần tài đến`,
	str_3_kf41ymtxfos1r: `Thuỷ cung`,
	str_3_ebudnqj68h6d4: `lễ hội vui vẻ`,
	str_3_9mqe9bhroi78s: `Vua khỉ vàng`,
	str_3_4d5kdkpqi6sk4: `Cuộc phiêu lưu đẫm máu`,
	str_3_5864tji8w113w: `Phong cách Thái`,
	str_3_1q36p58phmt6y: `Aladđin`,
	str_3_xtpy4bx49xhx1: `Khám phá Châu Phi`,
	str_3_69xaiyrbo4dae: `Lễ hội hóa trang`,
	str_3_z1pc5tp4zqhm1: `viên đạn bạc`,
	str_3_bes8675wqiigs: `Captain Treasure`,
	str_3_bwwza4umpbwsh: `Điệu múa của những chú gấu`,
	str_3_qieoeyodyyyoc: `Captain Treasure Phiên bản nâng cao`,
	str_3_rh8iwwntk3mie: `thế giới cá heo`,
	str_3_axt5pxf7sk35y: `Vương miện của tốc độ`,
	str_3_jbzd1cjsgh4dk: `Người sparta`,
	str_3_oqt9p9876m39y: `Kim tự tháp Aztec`,
	str_3_t656f48j75z6a: `đại dương xanh tuyệt vời`,
	str_3_s6xhiogba5dhe: `bóng đá`,
	str_11_102614: `Fafafa2`,
	str_11_102617: `Gigi`,
	str_11_102618: `nữ thần gợi cảm`,
	str_11_102619: `vua sư tử trắng`,
	str_11_102623: `Monkey King`,
	str_11_102612: `Bữa tiệc poker`,
	str_11_102620: `Vua của tốc độ cao`,
	str_11_10211: `thuyền trưởng giàu có`,
	str_11_10212: `biển ma`,
	str_11_10213: `cuộc ẩu đả của trùm ma túy`,
	str_11_802101: `trái tim của đại dương`,
	str_11_102621: `Kho báu của Thuyền trưởng`,
	str_11_102620: `Vua của tốc độ cao`,
	str_11_802601: `Giải thưởng nổ 777`,
	str_11_102612: `Bữa tiệc poker`,
	str_11_20264: `người hầu`,
	str_11_802604: `tiêu diệt thây ma`,
	str_11_802606: `Euro 2021`,
	str_11_202613: `quả chuối lớn`,
	str_11_202611: `Quỷ cáo`,
	str_11_102615: `Nữ hoàng phương Nam`,
	str_11_102616: `huyền thoại ai cập`,
	str_11_10264: `Sấm sét phong ấn vị thần`,
	str_11_702619: `thiên đường điên rồ`,
	str_13_7_7001: `Câu cá vua rồng`,
	str_13_7_7002: `Câu cá vua rồng2`,
	str_13_7_7003: `Câu cá Thần tài`,
	str_13_7_7004: `Câu cá năm rồng`,
	str_13_7_7005: `câu cá tất cả các cách`,
	str_13_7_7006: `Thợ săn rồng`,
	str_13_7_7007: `vũ trường câu cá`,
	str_13_0_8001: `rồng may mắn`,
	str_13_0_8002: `Hương thơm mùa thu của Tang Bohu`,
	str_13_0_8003: `thay đổi khuôn mặt`,
	str_13_0_8004: `Goku`,
	str_13_0_8005: `Cuộc phiêu lưu của Llama`,
	str_13_0_8006: `Gấu đen đài loan`,
	str_13_0_8007: `Lin may mắn`,
	str_13_0_8014: `Sư tử may mắn`,
	str_13_0_8015: `Kho báu ánh trăng`,
	str_13_0_8016: `nhân viên văn phòng rhapsody`,
	str_13_0_8017: `năm mới`,
	str_13_0_8018: `Napoléon`,
	str_13_0_8019: `Bốn Kho báu của Nghiên cứu`,
	str_13_0_8020: `Mở Sesame`,
	str_13_0_8021: `Đế chế chuối vàng`,
	str_13_0_8022: `Chiến binh chim sẻ`,
	str_13_0_8023: `Đền Olympia`,
	str_13_0_8024: `vương quốc pha lê`,
	str_13_0_8025: `kẻ trộm`,
	str_13_0_8026: `bố già khiêu vũ nóng bỏng`,
	str_13_0_8027: `Đầu bếp vua`,
	str_13_0_8028: `Những con chuột vàng may mắn`,
	str_13_0_8029: `Đảo kẹo giả tưởng`,
	str_13_0_8030: `nhà khoa học điên`,
	str_13_0_8031: `Bánh bao vàng`,
	str_13_0_8034: `người đàn ông có tiền`,
	str_13_0_8035: `Phượng hoàng may mắn`,
	str_13_0_8036: `vua rồng`,
	str_13_0_8037: `màn ảo thuật`,
	str_13_0_8044: `Vẻ đẹp đồng quê`,
	str_13_0_8046: `Quan Vũ`,
	str_13_0_8047: `thay đổi mặt 2`,
	str_13_0_8048: `Mở Vừng 2`,
	str_13_0_8049: `Hương thơm mùa thu của Tang Bohu2`,
	str_13_0_8050: `nhận tiền sớm`,
	str_13_0_15001: `Truyền tin của Gà trống vàng`,
	str_13_0_15002: `Vua khỉ`,
	str_13_0_15004: `Mảng lửa Bull`,
	str_13_0_15005: `Fuwa may mắn`,
	str_13_0_15006: `Đế chế Inca`,
	str_13_0_15009: `cuộc tấn công của ninja`,
	str_13_0_15010: `Đầu bếp gấu trúc`,
	str_13_0_15011: `Truyền thuyết về Hou Yi`,
	str_13_0_15012: `Ngũ phúc đến tận cửa`,
	str_13_0_15013: `cáo chín đuôi`,
	str_13_0_14001: `chọi gà`,
	str_13_0_14002: `Cuộc phiêu lưu của người Maya`,
	str_13_0_14003: `Gấu trúc Diaosi`,
	str_13_0_14004: `Truyền thuyết về Zelda`,
	str_13_0_14005: `Túi người lớn`,
	str_13_0_14006: `tỷ phú`,
	str_13_0_14007: `One Punch Man`,
	str_13_0_14008: `chiến binh rồng`,
	str_13_0_14010: `rồng bay trên bầu trời`,
	str_13_0_14011: `Những người bảo vệ thiên hà`,
	str_13_0_14012: `máy bay chiến đấu đường phố`,
	str_13_0_14013: `máy bay chiến đấu đường phố`,
	str_13_0_14015: `chiến tranh giữa các vì sao`,
	str_13_0_14016: `đại lý ace`,
	str_13_0_14017: `Tiền tuyến cô gái`,
	str_13_0_14018: `Daji`,
	str_13_0_14019: `Câu chuyện đá quý`,
	str_13_0_14020: `thần sữa ma thuật`,
	str_13_0_14021: `Tiền cuộn tiền`,
	str_13_0_14022: `ông trùm khai thác mỏ`,
	str_13_0_14023: `Vua bài xì phé`,
	str_13_0_14025: `Đua xe may mắn`,
	str_13_0_14026: `kiếm được nhiều tiền`,
	str_13_0_14027: `chúc may mắn 777`,
	str_13_0_14029: `Con thú phương đông`,
	str_13_0_14030: `King Kong gấp ba`,
	str_13_0_14033: `Bữa tiệc chim bay`,
	str_13_0_14034: `Gou Lai Fu`,
	str_13_0_14035: `Múa rồng`,
	str_13_0_14036: `Siêu bò B`,
	str_13_0_14038: `Kho báu Ai Cập`,
	str_13_0_14039: `May mắn và Kho báu`,
	str_13_0_14040: `Kho báu Bảy Biển`,
	str_13_0_14041: `Búa của Thor`,
	str_13_0_14042: `cái bát kho báu`,
	str_13_0_14043: `khiêu vũ`,
	str_13_0_14044: `Kỳ quặc King Kong`,
	str_13_0_14045: `Phiên bản Super Cow B Deluxe`,
	str_13_0_14046: `em bé khai thác`,
	str_13_0_14047: `tài phiệt`,
	str_13_0_14048: `rồng hổ hoang dã`,
	str_13_0_14049: `Quả nổ`,
	str_13_0_14050: `sóng biển`,
	str_13_0_14051: `Lôi Nguyệt Long Môn`,
	str_13_0_14052: `kho tàng rừng rậm`,
	str_13_0_14053: `sóng biển2`,
	str_13_0_14054: `siêu khoan`,
	str_13_0_14055: `Vua Kong`,
	str_13_0_14056: `Anh em nhà khủng long bạo chúa`,
	str_13_0_14057: `NinjaX`,
	str_13_0_14058: `Voi bay may mắn`,
	str_13_0_14059: `Siêu IV`,
	str_13_0_14060: `Đèn lồng vận may`,
	str_13_0_14061: `Maya Kim Điên`,
	str_13_0_14062: `chiến tranh đế quốc`,
	str_13_0_14063: `chim ba ba lớn`,
	str_13_0_14064: `bữa tiệc nổ`,
	str_13_0_14065: `giàu hoa`,
	str_13_0_14066: `Các hãng hàng không Star`,
	str_13_0_14067: `Cô gái da trắng, giàu có và xinh đẹp`,
	str_4_ermj: `Mạt chược cho hai người`,
	str_4_blackjack: `21 giờ`,
	str_4_sangong: `Sangong`,
	str_4_qydz: `Tất cả ở Texas`,
	str_4_zjh: `hoa chiên vàng`,
	str_4_blnn: `Niu Niu`,
	str_4_baccarat: `Bài Baccarat`,
	str_4_tbnn: `Tumblr Nữu Nữu`,
	str_4_hbmj: `thẻ năm sao`,
	str_4_dzmj: `Mạt chược phổ biến`,
	str_4_gdmj: `Mạt chược Quảng Đông`,
	str_4_hnmj: `Hồ Nam Mahjong`,
	str_4_rbwar: `chiến tranh đỏ đen`,
	str_4_hzmj: `Hàng Châu mạt chược`,
	str_4_mjxzdd: `trận chiến đẫm máu`,
	str_4_mjxlch: `sông máu`,
	str_4_gyzjmj: `Quý Dương bắt gà`,
	str_14_1001: `Haibawang`,
	str_14_1002: `ăn tôi một phát`,
	str_14_1003: `Câu cá Sanxian`,
	str_14_1004: `thợ săn rồng`,
	str_14_1006: `Làm giàu chỉ với một cái búa`,
	str_14_1007: `thực vật vs khủng long`,
	str_14_1009: `Three Immortals Split Fish`,
	str_14_2001: `Rồng vàng Hổ`,
	str_14_2002: `Trăm người gia súc`,
	str_14_2003: `chào tiền chiên hoa vàng`,
	str_14_2004: `28 thanh`,
	str_14_2006: `Bài Baccarat`,
	str_14_2005: `Sangong`,
	str_14_2007: `13 vùng nước`,
	str_14_2008: `Xì dách`,
	str_14_2009: `Texas Hold’em`,
	str_14_2010: `lấy một phong bì màu đỏ`,
	str_14_2011: `Nắm lấy Zhuang Niu Niu`,
	str_14_3001: `ông trùm kim cương`,
	str_14_3002: `Nhảy qua Cổng Rồng`,
	str_14_3003: `gửi nó lên`,
	str_14_3004: `Sư tử thống trị thế giới`,
	str_14_3005: `Kho báu bí mật lớn`,
	str_14_3006: `nhà tiên tri ai cập`,
	str_14_3007: `Thần tài đến`,
	str_14_3008: `Đại Đường`,
	str_14_3009: `Sư tử may mắn`,
	str_14_3010: `Con khỉ hiền triết lớn`,
	str_14_3011: `cướp kho tiền`,
	str_14_3012: `Năm con thú thánh`,
	str_14_3013: `Hãy hạnh phúc`,
	str_14_3014: `Ả Rập`,
	str_14_3015: `truyền thuyết sói đói`,
	str_14_3016: `tinh thể trái cây`,
	str_14_3017: `gôn`,
	str_14_3018: `Vua hổ`,
	str_14_3019: `thần zeus`,
	str_14_3020: `ma cà rồng`,
	str_14_3021: `Vua Hải Tặc`,
	str_14_3022: `alice`,
	str_14_3023: `hominids`,
	str_14_3024: `Leibalông`,
	str_14_3025: `vua của rạp xiếc`,
	str_14_3026: `Biến đá thành vàng`,
	str_14_3027: `Maya King`,
	str_14_3028: `Thanh trái cây`,
	str_14_3029: `Rồng thần tài`,
	str_14_3030: `Chúa tể khỉ vàng`,
	str_14_3031: `Chúa ban phước đến`,
	str_14_3032: `người đàn ông gấu trúc`,
	str_14_3033: `gửi ngay lập tức`,
	str_14_3034: `777`,
	str_14_3035: `ba con khỉ`,
	str_14_3036: `Zhao Yun Wushuang`,
	str_14_3037: `Phenix rực lửa`,
	str_14_3038: `Lu Ji Wushuang`,
	str_14_3039: `bao youfa`,
	str_14_3040: `nhiều cô gái`,
	str_14_3041: `nhiều cô gái hơn`,
	str_14_3042: `Thần thịnh vượng của sự giàu có`,
	str_14_3043: `Đưa tiền vàng cho mèo`,
	str_14_3044: `Flying Immortals`,
	str_14_3045: `chuột tiền`,
	str_14_3046: `đầu bếp nhỏ`,
	str_14_3047: `Pocari`,
	str_14_3048: `Bingguoba`,
	str_14_3049: `mắt vàng`,
	str_14_3050: `gà bom`,
	str_14_3051: `Họ rau thơm`,
	str_14_3052: `đế chế La Mã`,
	str_14_3054: `Thống trị nắm tay`,
	str_14_3055: `Vương triều Ai Cập`,
	str_14_3056: `Kho báu rồng ma thuật`,
	str_14_3057: `bạn sẽ đánh lừa`,
	str_14_3058: `những phong bì màu đỏ`,
	str_14_3059: `Chạy bò`,
	str_14_4001: `trò chơi bậc thang`,
	str_14_4002: `Bắn giàn`,
	str_14_4003: `trứng đào vàng`,
	str_14_4009: `Sẵn sàng để đi`,
	str_15_2: `Mạt chược cho hai người`,
	str_15_3: `Nắm lấy Zhuang Niu Niu`,
	str_15_4: `Trăm người gia súc`,
	str_15_5: `Câu cá vua rồng`,
	str_15_6: `nhiều tiền hơn và nhiều tài sản hơn`,
	str_15_7: `Jing Mi Chu Hand Dezhou`,
	str_15_8: `người đẩy`,
	str_15_9: `Nhân đôi cho chủ đất`,
	str_15_10: `Insurance Chu Hand Texas`,
	str_15_11: `trận chiến đẫm máu`,
	str_15_12: `hoa chiên vàng`,
	str_15_13: `phải đến Texas`,
	str_15_14: `Hàng trăm người san gong`,
	str_15_15: `13 vùng nước`,
	str_15_17: `Câu cá 3D`,
	str_15_19: `bập bênh vui vẻ`,
	str_15_20: `Tumblr Nữu Nữu`,
	str_15_22: `Bài Baccarat`,
	str_15_23: `28 thanh`,
	str_15_24: `Quảng Đông lật đổ Hu`,
	str_15_25: `Xì dách`,
	str_15_26: `Pinghu gà Quảng Đông`,
	str_15_33: `Classic Grab Zhuang Niu Niu`,
	str_15_35: `bóng rừng`,
	str_15_39: `chạy nhanh`,
	str_15_42: `sông máu`,
	str_15_44: `Rồng và Hổ chiến đấu`,
	str_15_45: `Nữu Nữu ăn nhỏ`,
	str_15_47: `hạnh phúc lật`,
	str_15_49: `Phiên bản mới của Doudizhu`,
	str_15_51: `Cá, tôm và cua`,
	str_15_52: `Nhìn vào bốn bức ảnh để lấy Zhuang Niuniu`,
	str_15_53: `San Gong ăn nhỏ`,
	str_15_55: `Mạt chược Đài Loan`,
	str_15_56: `cốc trái cây`,
	str_16_baccarat: `Bài Baccarat`,
	str_16_dragontiger: `Rồng hổ`,
	str_16_topcard: `hội trường bóng đá`,
	str_16_blackjack: `Xì dách`,
	str_16_scalableblackjack: `Blackjack không giới hạn`,
	str_16_roulette: `Trò chơi Roulette`,
	str_16_americanroulette: `Roulette kiểu Mỹ`,
	str_16_instantroulette: `Trò chơi Roulette mở theo thời điểm`,
	str_16_craps: `craps`,
	str_16_moneywheel: `Bánh xe may mắn / Bánh xe đuổi theo ước mơ`,
	str_16_sicbo: `Siêu Tài Xỉu`,
	str_101_100: 'Câu cá GB',
	str_1_300:'Vua rồng biển Đông',
	str_1_301:'Quyền bá chủ của Rồng và Hổ',
	str_1_302: 'Thần Zeus',
	str_1_303: `Đêm Sahara`,
	str_1_304: `Số của Zed`,
	str_gamesneme_0: `Nóng nhất`,
	str_gamesneme_1: `General drafting`,
	str_gamesneme_2: `Trò chơi`,
	str_gamesneme_3: `Điện tử`,
	str_gamesneme_4: `Địa phương`,
	str_gamesneme_5: `Đánh bắt cá`,
	str_gamesneme_6: `Lĩnh vực`,
	str_gamesneme_7: `gaming`,
	str_gamesneme_all: `Tất cả`,
	str_ChannelsName_1: `GB`,
	str_ChannelsName_2: `WM`,
	str_ChannelsName_3: `JOKER`,
	str_ChannelsName_4: `博樂`,
	str_ChannelsName_5: `SBO`,
	str_ChannelsName_6: `CQ9`,
	str_ChannelsName_7: `ไคหยวน`,
	str_ChannelsName_8: `BBIN `,
	str_ChannelsName_9: `SEXY `,
	str_ChannelsName_10: `DG`,
	str_ChannelsName_11: `FUNKY`,
	str_ChannelsName_12: `เลอ ทัวร์`,
	str_ChannelsName_13: `JDB`,
	str_ChannelsName_14: `DS`,
	str_ChannelsName_15: `VG`,
	str_ChannelsName_16: `EVO`,
	str_ChannelsName_101: `GB`,
	str_balanceType_5: `Nâng cấp tiền thưởng VIP`,
	str_balanceType_6: `Thưởng`,
	str_balanceType_7: `Rút tiền`,
	str_balanceType_8: `Nạp tiền`,
	str_balanceType_9: `Chuyển tiền`,
	str_balanceType_10: `Tặng tiền thưởng`,
	str_balanceType_11: `Nạp tiền thủ công`,
	str_balanceType_12: `Nhận tiền thưởng khi bạn nạp tiền`,
	str_balanceType_13: `Hoàn trả`,
	str_balanceType_14: `Hoạt động tặng lì xì`,
	str_balanceType_15: `Vòng quay giải thưởng`,
	str_balanceType_16: `Hoạt động đột phá`,
	str_balanceType_17: `Nạp tiền`,
	str_balanceType_18: `Chuyển tiền thưởng`,
	str_info_title: `Thông tin cá nhân`,
	str_info_portrait: `Hồ sơ`,
	str_info_name: `Tên`,
	str_info_phonenumber: `Số điện thoại`,
	str_info_nickname: `Tên nick`,
	str_info_bankcard: `Tài khoản ngân hàng`,
	str_info_birthday: `Ngày sinh nhật`,
	str_info_email: `E_mail`,
	str_maintain_maintain: `Bảo trì hệ thống`,
	str_maintain_sorry: `Bảo trì Hệ thống.Xin lỗi vì sự bất tiện`,
	str_activity_title: `Thành viên mới`,
	str_activity_tab1: `VI_Tất cả`,
	str_activity_tab2: `Muộn nhất`,
	str_activity_tab3: `Thành viên mới`,
	str_activity_tab4: `VIP`,
	str_activity_tab5: `Hằng ngày`,
	str_activitydt_title: `chi tiết sự kiện `,
	str_login_title: `Đăng nhập `,
	str_login_resSuccess: `đăng nhập thành công`,
	str_login_registernew: `Xem trước `,
	str_login_registernew2: `Đăng ký người dùng mới `,
	str_login_forget: `quên mật khẩu đăng nhập`,
	str_login_Login: `Đăng nhập`,
	str_register_title: `Đăng ký`,
	str_register_form_phonePl: `Vui lòng nhập số điện thoại`,
	str_register_form_passwords: `Vui lòng đặt mật khẩu đăng nhập 6_20 chữ số `,
	str_register_Download: `Tải xuống APP ngay bây giờ (được đề xuất)`,
	str_register_Enter: `tham gia trò chơi trực tuyến`,
	str_register_message_phone: `Vui lòng nhập số điện thoại`,
	str_register_message_code: `Vui lòng nhập mã xác minh điện thoại di động của bạn `,
	str_register_message_password: `Xin vui lòng nhập mật khẩu `,
	str_register_message_pwdlen: `Độ dài mật khẩu phải lớn hơn hoặc bằng 6 ký tự và ít hơn 20 ký tự`,
	str_register_message_pwdCon: `Nhập mật khẩu hai lần không đồng nhất`,
	str_register_message_pwd: `Vui lòng nhập lại mật khẩu `,
	str_register_message_agress: `Vui lòng đánh dấu để đồng ý với Thỏa thuận dịch vụ người dùng`,
	str_register_Tick: `Đánh dấu để đồng ý`,
	str_register_agreement: `Thỏa thuận dịch vụ người dùng`,
	str_register_registernow: `Đăng ký ngay`,
	str_register_existing: `Tài khoảnn đã có, đăng nhập ngay`,
	str_register_resSuccess: `đăng ký thành công `,
	str_register_getCode: `lấy mã xác minh`,
	str_password_title: `đặt lại mật khẩu`,
	str_password_oldpassword: `Vui lòng nhập mật khẩu ban đầu `,
	str_password_newpassword: `Vui lòng nhập mật khẩu mới`,
	str_password_password: `Vui lòng nhập mật khẩu xác nhận`,
	str_password_phone: `Vui lòng nhập số điện thoại`,
	str_password_code: `Vui lòng nhập mã xác minh điện thoại di động của bạn`,
	str_password_getCode: `lấy mã xác minh `,
	str_password_succeeded: `Đặt lại mật khẩu thành công `,
	str_password_Jump: `Chuyển đến trang đăng nhập `,
	str_password_Enter: `đi đến trang đăng nhập`,
	str_password_Verify: `Xác minh số điện thoại `,
	str_password_rebuild: `đặt lại mật khẩu `,
	str_password_complete: `Hoàn thành`,
	str_safety_title: `Thiết lập mật khẩu thanh toán`,
	str_safety_pwd: `Sửa đổi mật khẩu đăng nhập`,
	str_safety_payPwd: `Đặt mật khẩu rút tiền`,
	str_pwd_title: `Sửa đổi mật khẩu đăng nhập`,
	str_service_title: `dịch vụ khách hàng`,
	str_service_contentOpen: `Đăng ký ngay `,
	str_service_contentzhuan: ``,
	str_service_contentzhuce: `Đăng ký tư vấn`,
	str_service_contentfuwu: ``,
	str_my_title: `Của tôi`,
	str_my_box_jiaoyi: `Lịch sử giao dịch`,
	str_my_box_touzhu: `Lịch sử cược`,
	str_my_box_dengji: `Chuyển đổi điểm`,
	str_my_box_tuiguang: `Số dư `,
	str_my_balance: `thăng bằng`,
	str_my_fanyong: `Chiết khấu hoa hồng hôm nay`,
	str_my_recharge: `Nạp`,
	str_my_withdrawal: `rút`,
	str_my_personal: `thông tin cá nhân`,
	str_my_bank: `tài khoản ngân hàng `,
	str_my_account: `Bảo vệ tài khoản `,
	str_my_vip: ``,
	str_my_Download: `Tải xuống APP`,
	str_my_news: `tin nhắn của tôi `,
	str_my_upgrade: `nâng cấp `,
	str_my_eliminate: `xóa bộ nhớ cache `,
	str_my_out: `Đăng xuất `,
	str_withdrawal_binding: `Vui lòng chọn phương thức rút tiền`,
	str_withdrawal_number: `Số đuôi`,
	str_withdrawal_bankcard: `Thẻ ngân hàng`,
	str_withdrawal_Disable: `Người dùng bị vô hiệu hóa `,
	str_withdrawal_balance: `Cân bằng `,
	str_withdrawal_quota: `Số tiền có thể rút`,
	str_withdrawal_money: `Số tiền rút `,
	str_withdrawal_minimum: `Số tiền rút tối thiểu`,
	str_withdrawal_withdraw: `Vui lòng nhập mật khẩu rút tiền gồm 6 chữ số`,
	str_withdrawal_regulations: `Số tiền rút tối thiểu`,
	str_withdrawal_Withdrawals: `rút`,
	str_withdrawal_Please_enter: `Vui lòng nhập số tiền rút `,
	str_withdrawal_Insufficient: `Không đủ số dư để rút tiền`,
	str_withdrawal_greater_than: `Số tiền rút phải lớn hơn`,
	str_withdrawal_password: `Vui lòng nhập mật khẩu rút tiền `,
	str_withdrawal_success: `Đăng ký rút tiền thành công`,
	str_withdrawal_set_up: `Vui lòng đặt mật khẩu thanh toán trước khi rút tiền`,
	str_withdrawal_choice: `Vui lòng chọn một thẻ ngân hàng `,
	str_integral_title: `Chuyển đổi điểm`,
	str_integral_IntegralIncrease: `điểm tăng lên`,
	str_integral_PointExchange: `Đổi thưởng`,
	str_integral_available: `Điểm có sẵn`,
	str_integral_time: `thời gian`,
	str_integral_lable: `tích phân`,
	str_spread_title: `Mời tham gia`,
	str_spread_can: `Số tiền khả dụng `,
	str_spread_amount: `Số tiền chuyển khoản`,
	str_spread_Cumulative: `Hoa hồng tích lũy`,
	str_spread_team: `Tổng số đội `,
	str_spread_commission: `hoa hồng hôm nay `,
	str_spread_extension: `Số người giới thiệu hôm nay`,
	str_spread_Promotion: `kênh quảng cáo một`,
	str_spread_Promotion2: `Kênh quảng cáo hai`,
	str_spread_Promotion_link: `Liên kết khuyến mại `,
	str_spread_copy: `Sao chép liên kết cho bạn bè `,
	str_spread_preservation: `Lưu mã QR lời mời`,
	str_spread_Commission: `Số dư chuyển khoản hoa hồng`,
	str_spread_notes: `Nhận xét: Tiền hoa hồng sau khi chuyển vào số dư khả dụng có thể rút ra`,
	str_spread_all: `chuyển tất cả`,
	str_spread_success: `đã lưu thành công`,
	str_spread_fail: `Lưu thất bại`,
	str_spread_alls_all: `Tất cả`,
	str_spread_alls_level: `Cấp độ`,
	str_spread_alls_search: `Tìm kiếm `,
	str_spread_alls_account: `Tài khoản`,
	str_spread_alls_generation: `Thế hệ mấy`,
	str_spread_alls_today: `Cược tích lũy`,
	str_spread_alls_team: `Kích thước nhóm`,
	str_record_trade: `Lịch sử giao dịch`,
	str_record_betting: `Lịch sử cược`,
	str_record_No_data: ``,
	str_record_searchText_0: `Hôm nay`,
	str_record_searchText_2: `3 ngày gần đây `,
	str_record_searchText_6: `7 ngày gần đây `,
	str_record_searchText_29: `30 ngày gần đây`,
	str_record_topText: ``,
	str_record_betting_title: ``,
	str_bettingDetail_pingtai: `Tên web`,
	str_bettingDetail_title: `Chi tiết cược`,
	str_bettingDetail_name: `têntrò chơi `,
	str_bettingDetail_channel: `loại trò chơi`,
	str_bettingDetail_orderStatus: `Tình trạng đơn `,
	str_bettingDetail_gameType: `Tình trạng đơn `,
	str_bettingDetail_dateDesc: `thời gian cá cược`,
	str_bettingDetail_accountDesc: `Tổng số tiền đặt cược`,
	str_bettingDetail_lotteryAccount: `số tiền thắng cuộc`,
	str_bettingDetail_orderNo: `mã đặt cược `,
	str_bettingDetail_state0: ``,
	str_bettingDetail_state1: ``,
	str_bettingDetail_state2: ``,
	str_card_title: `thẻ ngân hàng`,
	str_card_bankName: ``,
	str_card_bankNamePl: ``,
	str_card_bankNo: ``,
	str_card_zskNo: ``,
	str_card_zskNo1: ``,
	str_card_bankNoPl: ``,
	str_card_name: `Tên`,
	str_card_namePl: `Vui lòng nhập tên tiếng Anh`,
	str_card_tips: `Vui lòng đồng nhất với tên thật của bạn, nếu không sẽ ảnh hưởng đến việc rút tiền
Sau khi thông tin được gửi đi, chỉ có thể được sửa đổi thông qua thông báo cho nhân viên chăm sóc khách hàng`,
	str_card_default: `Thẻ ngân hàng`,
	str_card_choice: `Vui lòng chọn một ngân hàng`,
	str_card_Enterbankcard: `Vui lòng nhập tên ngân hàng để tìm kiếm`,
	str_card_search: `Tìm kiếm`,
	str_card_binding: `ràng buộc`,
	str_record_trading_title: `chi tiết giao dịch`,
	str_record_trading_type: `loại`,
	str_record_trading_orderNo: `Đơn số`,
	str_record_trading_dateTime: `thời gian`,
	str_record_trading_desc: `Ghi chú đánh giá`,
	str_record_trading_progress: `tiến độ hiện tại`,
	str_record_trading_copysuccess: `Sao chép thành công`,
	str_record_trading_Recharge: `Sao chép thành công`,
	str_code_500: `Hệ thống đang bận`,
	str_code_4000: `chưa đăng nhập`,
	str_code_4001: `Lỗi tham số`,
	str_code_4002: `Lỗi mã xác minh`,
	str_code_4003: `tài khoản hoặc mật khẩu không chính xác`,
	str_code_4004: `không có phương pháp này`,
	str_code_4005: `người dùng không tồn tại`,
	str_code_4006: `Số điện thoại di động chưa được xác minh`,
	str_code_4007: `Số điện thoại di động đã được đăng ký`,
	str_code_4008: `Thẻ này không được hỗ trợ`,
	str_code_4009: `Người dùng đã ràng buộc một thẻ ngân hàng`,
	str_code_4010: `Đăng nhập trò chơi không thành công`,
	str_code_4011: `Ngày sinh đã được ràng buộc`,
	str_code_4012: `Tên thật đã được ràng buộc`,
	str_code_4013: `Thẻ ngân hàng chưa được ràng buộc`,
	str_code_4014: `Thẻ ngân hàng đã chọn không phù hợp với thẻ ngân hàng được ràng buộc`,
	str_code_4015: `Tài khoản đã bị vô hiệu hóa`,
	str_code_4016: `Khuyến mãi chưa nhận đã mất`,
	str_code_4017: `Mật khẩu ban đầu đã được nhập không chính xác`,
	str_code_4018: `mật khẩu cũ và mới phải giống nhau`,
	str_code_4019: `Mật khẩu rút tiền sai`,
	str_code_4020: `Mật khẩu rút tiền cũ và mới phải giống nhau`,
	str_code_4021: `Mật khẩu rút tiền không bị ràng buộc`,
	str_code_4022: `Tên thật đã điền không phù hợp với tên thật ràng buộc`,
	str_code_4023: `Hoạt động chưa mở`,
	str_code_4024: `Không yêu cầu được đề nghị`,
	str_code_4025: `không có sự kiện như vậy`,
	str_code_4026: `Sự kiện vẫn chưa được đổi`,
	str_code_4027: `đã nhận khuyến mãi này`,
	str_code_4028: `Bạn đã có tài khoản để yêu cầu ưu đãi`,
	str_code_4029: `Điều kiện nạp tiền không được đáp ứng`,
	str_code_4030: `Không có khuyến mãi để nhận`,
	str_code_4031: `Không đủ điểm`,
	str_code_4032: `nhiệm vụ chưa hoàn thành`,
	str_code_4033: `Đã nhận chiết khấu`,
	str_code_4034: `Phiếu mua hàng đã hết hạn`,
	str_code_4035: `Không phải lúc để lấy`,
	str_code_4036: `Đã nhận được giảm giá hôm nay`,
	str_code_4037: `Không có chiết khấu`,
	str_code_4043: `Không có đề nghị chuyển vào`,
	str_code_4044: `Quá nhiều đơn đặt hàng chưa thanh toán, vui lòng liên hệ với bộ phận chăm sóc khách hàng`,
	str_code_4045: `Không gửi được mã xác minh, vui lòng liên hệ với bộ phận chăm sóc khách hàng`,
	str_code_4046: `Bạn có số tiền rút chưa thanh toán, vui lòng chờ xử lý`,
	str_name_title: `tên thật`,
	str_name_name: `tên thật`,
	str_name_namePl: `vui lòng nhập tên thật của bạn`,
	str_name_tips: `Tên thật phải trùng khớp với thẻ ngân hàng, nếu không sẽ ảnh hưởng đến việc rút tiền. Sau khi thông tin được gửi đi, chỉ có thể được sửa đổi thông qua thông báo cho nhân viên chăm sóc khách hàng`,
	str_nick_title: `Tên biệt danh`,
	str_nick_nick: `Tên biệt danh`,
	str_nick_nickPl: `Hãy nhập một tên biệt danh`,
	str_email_title: `Ràng buộc email`,
	str_email_email: `Email`,
	str_email_emailPl: `Vui lòng nhập địa chỉ email`,
	str_facebook_title: `Ràng buộc Facebook`,
	str_facebook_facebook: `Facebook`,
	str_facebook_facebookPl: `Vui lòng nhập tài khoản Facebook`,
	str_line_title: `Ràng buộc tài khoản Line`,
	str_line_line: `Line`,
	str_line_linePl: `Vui lòng nhập tài khoản Line của bạn`,
	str_birthday_title: `ràng buộc ngày sinh`,
	str_birthday_birthday: `Ngày sinh nhật`,
	str_birthday_birthdayPl: `Vui lòng chọn ngày sinh`,
	str_vipList_title: `Nhận thưởng`,
	str_vipList_tip: `Nâng cấp tiền thưởng`,
	str_vipList_yuan: `Nhân dân tệ`,
	str_vipList_yi: ` Đã nhận`,
	str_vipList_now: `Nhận ngay`,
	str_viprules_title: `Quy tắc nâng cấp`,
	str_viprules_tip: `Nâng cấp tiền thưởng`,
	str_viprules_e: `số tiền đặt cược`,
	str_viprules_leiji: `nạp tiền`,
	str_vip_title: `Xếp hạng đặc biệt`,
	str_vip_content_current: `Đặt cược hiện tại`,
	str_vip_content_difference: `Vẫn thiếu`,
	str_vip_content_Bet: `Đặt cược để nâng cấp lên`,
	str_vip_content_receive: `Nhận tiền thưởng nâng cấp`,
	str_vip_content_Betamount: `Số tiền đặt cược (nhân dân tệ)`,
	str_vip_content_Recharge: `Nạp tiền (nhân dân tệ)`,
	str_vip_content_Promotion: `Nâng cấp tiền thưởng (nhân dân tệ)`,
	str_vip_content_vip: `Đặc quyền VIP`,
	str_vip_content_see: `xem tất cả`,
	str_vip_content_Promotiongift: `Nâng cấp tiền thưởng`,
	str_vip_content_More: `nhiều đặc quyền hơn`,
	str_vip_content_wait: `Giữ nguyên`,
	recharge_title: `Sắp diễn ra`,
	str_recharge_channel: `lối đi`,
	str_recharge_choice: `lựa chọn`,
	str_recharge_zfb: `Alipay`,
	str_recharge_payment: `phương thức thanh toán`,
	str_recharge_money: `Số tiền nạp`,
	str_recharge_Please: `Vui lòng nhập số tiền nạp`,
	str_recharge_amount: `Chỗ nạp tiền`,
	str_recharge_yuan: `Nhân dân tệ`,
	str_recharge_immediately: `Nạp tiền ngay bây giờ`,
	str_recharge_order: `số thứ tự`,
	str_recharge_platform: `Nền tảng thanh toán`,
	str_recharge_username: `tên tài khoản`,
	str_recharge_account: `tài khoản`,
	str_recharge_copy: `sao chép`,
	str_recharge_payments: `xác nhận thanh toán`,
	str_recharge_dcWallet: `ví tiền ảo`,
	str_recharge_Tips: `Lời khuyên:`,
	str_with_title: `Pha chế`,
	str_balance_title: `Chi tiết số dư`,
	str_balance_total: `Tổng số dư (nhân dân tệ)`,
	str_avatar_title: `hình đại diện`,
	str_lucky_title: `Ưu đãi may mắn`,
	str_lucky_namePl: `Vui lòng nhập mã khuyến mãi`,
	str_lucky_tp: `Chúc mừng bạn đã giành được giải thưởng may mắn`,
	str_lucky_info: `Vui lòng liên hệ bộ phận chăm sóc khách hàng để lấy mã giảm giá`,
	str_lucky_bot: `Ưu đãi lên đến 5866 nhân dân tệ`,
	str_lucky_tips: `Kiếm tiền thưởng sau khi gửi tiền vào trò chơi`,
	str_lucky_resSuccess: `Đã nhận thành công`,
	str_rebate_title: `hạ giá`,
	str_rebate_btn: `Giảm giá VIP`,
	str_rebate_lingqu: `yêu cầu tiền thưởng`,
	str_rebate_footTip: `Nhận tiền thưởng của bạn ngay hôm nay`,
	str_rebate_table: `thời gian, tên trò chơi, số lượng xáo trộn, tỷ lệ giảm giá, tiền thưởng giảm giá, trạng thái`,
	str_vip_rebate_title: `Hoa hồng VIP`,
	str_vip_rebate_vip: `Cấp độ VIP`,
	str_log_titleW: `Lịch sử rút tiền `,
	str_log_titleR: `Lịch sử nạp tiền`,
	str_log_amount: `số tiền`,
	str_log_Application: `thời gian nộp đơn`,
	str_log_Audit: `Thời gian xem xét`,
	str_log_state: `trạng thái`,
	str_log_Tobepaid: `Thanh toán`,
	str_log_success: `thành công`,
	str_log_Paid: `Đã thanh toán`,
	str_log_close: `đơn hàng đã đóng`,
	str_log_launch: `Gửi thanh toán`,
	str_log_WithdrawalSucceeded: `thanh toán thành công`,
	str_log_WithdrawalFailed: `Không rút được`,
	str_log_remarks: `Nhận xét`,
	str_log_nothing: `không`,
	str_log_shenhe: `đang xem xét`,
	str_rush_title: `Daily first charge`,
	str_phone_title: `Modify phone`,
	str_lower_title: `Tiêu đề`,
	str_achievememt_title: `số tài khoản`,
	str_achievememt_account: `Trực tiếp`,
	str_achievememt_directly: `Doanh thu`,
	str_achievememt_achievement: `Thêm mới`,
	str_achievememt_newly: `Thêm mới`,
	str_achievememt_team: `Nhóm `,
	str_achievememt_income: `Thu được`,
	str_achievememt_commission: `Tiền hoa hồng`,
	str_achievememt_detailed: `Chi tiết`,
	str_achievememt_item: ``,
	str_achievememt_user: `Tên người chơi`,
	str_achievememt_date: `Ngày `,
	str_memberdetails_title: `Danh sách người chơi`,
	str_team_title: `Tiền hoa hồng nhóm `,
	str_message_title: `Tin tức`,
	str_message_system: `Hệ thống`,
	str_message_business: `Tin tức kinh doanh `,
	str_message_Loading: `Đang tải`,
	str_message_No: `Hết`,
	str_msg_title: `Chi tiết`,
	str_game_list_title: `Game điện tử `,
	str_update_edition: `Cập nhật phiên bản mới`,
	str_update_Updating: `Đang cập nhật`,
	str_update_progress: `Tiến trình cập nhật`,
	str_update_fail: `Cập nhật thất bại`,
	str_update_determine: ` Chắc chắn cập nhật`,
	str_index_top: `GB `,
	str_top_content: `Live entertainment, sports betting and electronic entertainment are all in one hand`,
	str_top_xiazai: `Download`,
	str_Totalbet: `Total bet`,
	str_Totalwinorlose: `Total win or lose`,
	str_record_platform: `platform`,
	str_record_platform2: `Effective betting`,
	str_winorlose: `Win or lose`,
	str_record_zhudan: `Note sheet`,
	str_trade_all: `whole`,
	str_trade_caijin: `Lottery money`,
	str_trade_tixian: `Withdrawal`,
	str_trade_chongzhi: `Recharge`,
	str_trade_fanyong: `Return commission`,
	str_trade_erdu: `Quota conversion`,
	str_trade_shoudong: `Manual recharge`,
	str_trade_cengjin: `Recharge gift`,
	str_trade_tuihui: `Withdrawal return`,
	str_qukuan: 'Please enter the login password',
	str_qukuan_mima: 'Please enter the original withdrawal password',
	str_login_forget2: 'If you forget your login password',
	str_chongzhi: 'Reset password',
	str_qukuanmima: 'If you forget the original withdrawal password, please',
	str_lianxi: 'Contact customer service',
	str_spread_suoyou: `tất cả cấp dưới`,
	str_spread_tuandui: `Hiệu suất của đội`,
	str_spread_fanyong: `Tỷ lệ chiết khấu`,
	str_qukuan: `Vui lòng nhập mật khẩu đăng nhập`,
	str_qukuan_mima: `Vui lòng nhập mật khẩu rút tiền ban đầu`,
	str_login_forget2: `Nếu bạn quên mật khẩu đăng nhập của mình`,
	str_chongzhi: `đặt lại mật khẩu`,
	str_qukuanmima: `Nếu bạn quên mật khẩu rút tiền ban đầu, vui lòng`,
	str_lianxi: `liên hệ với dịch vụ khách hàng`,
	str_wenxin: `Thủ thuật`,
	str_card_tishi: `Thành viên chỉ có thể ràng buộc một tài khoản thẻ ngân hàng và một tài khoản FPS, và tên của chủ tài khoản phải giống nhau. Nếu bạn cần sửa đổi sau khi ràng buộc, vui lòng liên hệ với dịch vụ khách hàng trực tuyến 24 giờ của chúng tôi.`,
	str_service_contentchongzhi: `Recharge consultation`,
	str_my_zhanghao: `Account number`,
	str_go_index: `Quay về trang nhà`,
	str_tiem_chaxun: 'Query days cannot be greater than 30 days',
	str_Platform_name: 'Platform name',
	str_Bet_amount: `Bet amount`,
	str_Other_games: `Other games`,
	str_Reset: 'Reset',
	str_less_than: 'The query interval must be less than 30 days',
	str_What_level: `What level`,
	str_fishing: 'fishing',
	str_Electronics: 'Electronics',
	str_Chess_cards: 'Chess and cards',
	str_lottery: `lottery`,
	str_Real_person: `Real person`,
	str_Sports: `Sports`,
	str_Copy_link: `Copy connection to friends`,
	str_withdrawal_mode: 'Hãy chọn phương pháp rút lui',
	str_bank_card: 'Thẻ ngân hàng',
	str_vip_content_betRecharge: 'Nạp điện',
	str_vip_content_Bet2: 'Nạp lại để nâng cấp',
	str_vip_leves: 'Nâng cấp phải đáp ứng một trong những điều kiện sau đây',
	str_vip_leves2: 'Có hai điều kiện nâng cấp',
	str_first_charge: 'Todays first charge amount:',
	str_received: 'Todays bonus:',
	str_Require: 'First deposit amount requirement',
	str_give_away: 'Gift bonus',
	str_xima_fanli: 'Shuffle code rebate',
	str_maintain: 'This platform is under maintenance, please change to another platform to play the game',
	str_rebate_table1: `Time`,
	str_rebate_table2: `Game name`,
	str_rebate_table3: `Code washing quantity`,
	str_rebate_table4: `Return water ratio`,
	str_rebate_table5: `Return water color gold`,
	str_rebate_table6: `Status`,
	str_wan: '',
	str_one_chong: '1stTop-up',
	str_one_chong: 'khoản phí đầu tiên',
	str_recharge_chongzhi: 'vị trí nạp tiền',
	str_recharge_card: 'số thẻ thanh toán',
	str_xima_shouming: 'Mô tả sự kiện',
	str_xima_1: '1. Chuỗi nạp tiền hàng ngày đầu tiên lớn hơn 100.00 và Tiền thưởng sẽ được trao ',
	str_xima_2:' 2. Tiền thưởng gửi càng cao. Các phần thưởng khác Xem bảng để biết chi tiết ',
	str_xima_3:' 3. Thời gian làm mới sự kiện, 0:00 hàng ngày. ',
	str_xima_4:' 4. Nhật ký xác nhận quyền sở hữu có thể được xem trong nhật ký giao dịch ',
	str_qianbao_guanli:' Wallet Management ',
	str_massge_my:' My Messages ',
	str_go_login:' Go To Login ',
	str_no_login:' Not S Sign In ',
	str_one_chong:' First Billing ',
	str_xima_5:' 2 Mã Giảm Giá Máy Tính Hoàn Trả Đồng Hồ Hàng Ngày. Vào những ngày trước hãy đặt cược ',
	str_xima_6:' 2. Tỷ lệ hoàn trả "50" có nghĩa là 50 cho mỗi 10.000 cược hợp lệ ',
	str_rebate_wei:' Không đạt tiêu chuẩn ',
	str_vip_rebate_title2:' Event Descr',
	str_download_copy: 'Sao chép liên kết',
	str_tigong: 'Cung cấp cho bạn ứng dụng khách di động tốt nhất,',
	str_suixing: 'Du lịch di động, để bạn vui chơi',
	str_baocun: 'Lưu mã QR',
	str_balance:'THĂNG BẰNG',
	str_colose: 'Đóng',
	str_index:'trang chủ',
	str_about:'Về chúng ta',
	str_service:'dịch vụ sản phẩm trò chơi',
	str_service_desc:'Cảm ơn bạn đã sử dụng các sản phẩm và dịch vụ trò chơi của SWG, SWG cung cấp các trò chơi điện tử chuyên nghiệp, chúng tôi có kinh nghiệm trò chơi phong phú và hơn 50 API trò chơi mang đến cho bạn trải nghiệm trò chơi tốt nhất!',
	str_multivariate:'Giải trí đa dạng',
	str_multivariate_desc:'Bao gồm sự phát triển của máy đánh bạc, máy câu cá, trò chơi nhỏ, xổ số điện tử, và các loại trò chơi điện tử khác, và đặc biệt giỏi ở máy đánh bạc và trò chơi máy câu cá.',
  str_jump_height: 'Jump Height',
  str_jump_amount: 'Jump Amount',
  str_special_Games: 'trò chơi đặc biệt:',
  str_three_yuan: 'Chung Pháp Bạch',
  str_luckiest_man: 'Sinh nhật lần thứ tư',
  str_lightning_jet: 'Lightning Jet',
  str_none:'không có',


}



// WEBPACK FOOTER //
// ./src/VueI18n/language-vn.js